/**
 * Whether a multi-value filter requires all of the selected values or any one
 * of them (PRO-1373).
 *
 * The string values are sent verbatim as query parameters and persisted in
 * saved views / emailed reports, so they must stay in sync with the backend
 * MATCH_ALL / MATCH_ANY constants in capitan-server
 * (apps/capitan_server/filters.py). An absent parameter means `all`, which is
 * how these filters behaved before the mode was selectable — so `all` is
 * represented as an absent/undefined filter key everywhere in this app, and
 * an explicit `all` value is never stored or serialized (loaders and setters
 * both enforce this).
 *
 * This module is pure TypeScript (no Angular or browser dependencies) so it may
 * be imported anywhere, including the reporting-core layer.
 */
export enum FilterMatchMode {
  all = 'all',
  any = 'any',
}
